import { useEffect, useState } from "react";
import Banner from "../components/Banner/Banner";
import "../assets/styles/Home.css";
import MatchCard from "../components/MatchCard/MatchCard";
import Footer from "../components/Footer/Footer";
import Marquee from "../components/Marquee";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserData,
  newSky,
  selectDomainID,
  selectSite,
  selectwhatsappSupport,
} from "../../../AsianExchangeSrc/utils/helper/commonSelectors";
import WhatsappIcon from "../../../AsianExchangeSrc/assets/images/Whatsapp-icon.png";
import { setUserData } from "../../../AsianExchangeSrc/redux/slices/userSlice";
import MatchCard2 from "../components/MatchCard/MatchCard2";
import { toast } from "react-toastify";
import { updateCasinoSlice } from "../../../AsianExchangeSrc/redux/slices/casinoSlice2";
import axios from "axios";

const newsItems = [
  {
    date: "07 Dec 2024",
    event: "New Zealand v England",
    market: "30 Over NZ '96.300.500' (IST 03:46:09 - 03:47:12)",
    message:
      "Bets Voided Because Wrong Rate Offered By Mistake .. Sorry for the Inconvenience Caused",
  },
  {
    date: "07 Dec 2024",
    event: "Victoria v Rangpur Riders",
    market: "11 Over VIC '89.75.125' (IST 07:32:54 - 07:33:10)",
    message:
      "Bets Voided Because of Wrong Rate Offered By Mistake .. Sorry for the Inconvenience Caused",
  },
];

const Home = () => {
  const siteDetails = useSelector(selectSite());
  const domainId = useSelector(selectDomainID());
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  // Get casino data from Redux store
  const casinoApiData = useSelector((state) => state.casino.casinoApiData);
  const userData = useSelector(getUserData())
  const whatsappSupport = useSelector(selectwhatsappSupport())
  useEffect(() => {
    if (!domainId) {
      setIsLoading(false);
      return;
    }

    // If casinoApiData already exists in Redux, use it and skip the API call
    if (casinoApiData && casinoApiData.length > 0) {
      setIsLoading(false);
      return;
    }

    // Otherwise, fetch the data
    const fetchCasino = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `https://api.asianexchange.club/api/int/getIntCasinos?domainId=${domainId}`
        );
        const data = response?.data || [];
        // Store the raw API data in Redux
        dispatch(updateCasinoSlice({ casinoApiData: data }));
      } catch (error) {
        console.error("Error fetching casino data:", error);
        toast.error("Failed to fetch casino data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchCasino();
  }, [domainId, dispatch, casinoApiData]);

  const SkyDesign = useSelector(newSky());
  const navItems = [
    { name: "In-Play", to: "/inplay" },
    { name: "Cricket", to: "/cricket" },
    { name: SkyDesign === "true" ? "Football" : "Soccer", to: "/soccer" },
    { name: "Tennis", to: "/tennis" },
    { name: "Casino", to: "/" },
    { name: "Horse Race", to: "/horse" },
  ];
  const IsLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <>
      <div
        className="main-wrap px-1"
        style={SkyDesign === "true" ? { padding: "2px" } : {}}
      >
        <div className={`sm:hidden block`}>
          {SkyDesign === "true" ? (
            <>
              <Marquee />
              <section className="flex bg-black text-white overflow-x-scroll text-nowrap">
                {navItems?.map((item, index) => (
                  <Link
                    key={index}
                    to={item.to}
                    className="px-4 py-1.5 border-r text-xs border-gray-700 hover:bg-gray-800 transition-colors"
                  >
                    {item.name}
                  </Link>
                ))}
              </section>
            </>
          ) : (
            ""
          )}
        </div>
        <Banner />


        {SkyDesign === "true" ? (
          <MatchCard gameData={casinoApiData} />
        ) : (
          <MatchCard2 gameData={casinoApiData} />
        )}

        <Footer />
        {(siteDetails?.whatsappSupport || whatsappSupport) && IsLoggedIn && (
          <div id="dvWhatsAppSupport" className="sm:mr-10">
            <a
              href={IsLoggedIn?`https://wa.me/${whatsappSupport?.replaceAll(
                " ",
                ""
              )}`:"#"}
              target={IsLoggedIn&&"_blank"}
              className="switcher-toggle"
            >
              <span className="pollicon">
                <img
                  src={WhatsappIcon}
                  alt="whatsapp-icon"
                  className="fa-brands fa-whatsapp"
                />
              </span>
            </a>
          </div>
        )}
      </div>
    </>
  );
};

export default Home;
